export default "/institutions/riachuelo.svg";